<script setup>
import { useStore } from "vuex";
import { ref } from "vue";
import Auth from "@aws-amplify/auth";
import CommonModal from "./CommonModal.vue"; // 共通モーダルのインポート
import { cleanupAutoLogout } from "@/utils/autoLogout";

const store = useStore();
const cognitoEnvironment = process.env.VUE_APP_COGNITO_ENVIRONMENT;
const isLoading = ref(false);

// モーダル用の関数
function onCancel() {
  // 何もしない（モーダルを閉じるだけ）
}
async function onLogout() {
  isLoading.value = true;
  try {
    cleanupAutoLogout();

    // 別タブ等ですでにセッションが破棄されている場合は Hosted UI logout に飛ばさず '/' へ遷移する
    try {
      await Auth.currentSession();
    } catch (e) {
      window.location.href = "/";
      return;
    }

    await store.dispatch("logout");
    const logoutUri = `https://${process.env.VUE_APP_AWS_COGNITO_DOMAIN_PREFIX}.auth.eu-central-1.amazoncognito.com/logout?client_id=${process.env.VUE_APP_AWS_COGNITO_USER_WEB_CLIENT_ID}&logout_uri=${process.env.VUE_APP_AWS_COGNITO_REDIRECT_URL}`;
    window.location.href = logoutUri;
  } catch (error) {
    console.error("Error during sign out:", error);
  } finally {
    isLoading.value = false;
  }
}
</script>

<template>
  <!-- loading spiner 表示-->
  <div v-if="isLoading" class="loading">
    <div class="spinner-border text-light" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div
    id="header"
    class="pt-2 pb-2 d-flex justify-content-center align-items-center flex-column"
  >
    <!-- flex-directionをcolumnに設定 -->
    <div class="title">
      Motorcycle Checklist Upload System
      <span v-if="cognitoEnvironment !== 'PR'" class="env-text"
        >({{ cognitoEnvironment }})</span
      >
    </div>
  </div>
  <div
    v-if="store.getters.isAuthenticated"
    class="user-info d-flex justify-content-between align-items-center"
  >
    <div class="user-email">
      <i class="bi bi-person-circle user-icon"></i>{{ store.getters.email }}
    </div>
    <!-- ログアウトボタンをモーダル起動用に変更 -->
    <button
      class="signout-button"
      data-bs-toggle="modal"
      data-bs-target="#logoutModal"
    >
      Log out
    </button>
  </div>
  <!-- 共通モーダルの呼び出し -->
  <CommonModal
    modalId="logoutModal"
    message="Do you want to Log out?"
    :buttons="[
      { label: 'Cancel', class: 'btn btn-outline-dark custom-border-btn fw-bold', onClick: onCancel },
      { label: 'Log out', class: 'btn btn-danger fw-bold', onClick: onLogout }
    ]"
  />
</template>

<style scoped>
#header {
  background: #00368f;
  color: white;
}

.user-icon {
  margin-right: 5px; /* アイコンとテキストの間にマージンを設定 */
}

.title {
  font-size: 100%; /* 追加: タイトルのフォントサイズを大きくする */
  font-weight: bold; /* 追加: タイトルのフォントウェイトを太くする */
}

.env-text {
  color: red; /* 環境変数のテキストを赤くする */
  font-size: 100%;
}

.user-info {
  font-size: 100%; /* 追加: ユーザー情報とサインアウトボタンのフォントサイズを小さくする */
  padding: 5px 10px 0px 10px; /*パディングを設定する*/
  width: 100%; /* 幅を100%に設定 */
}

.user-email {
  display: flex;
  align-items: center;
}

.signout-button {
  background-color: #00368f; /* ボタンの背景色を青にする */
  color: #ffffff; /* ボタンの文字色を白にする */
  border: none;
  font-weight: bold;
  padding: 5px 5px; /*パディングを設定する*/
  text-align: center; /* テキストを中央寄せにする */
  display: inline-block;
  margin: 2px 2px;
  cursor: pointer; /* カーソルをポインターにする */
  border-radius: 8px; /* ボタンの角を丸くする */
}

/* ローディング状態を表示するスタイルを追加 */
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
</style>